/**
 * @copyright Copyright 2015 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "MW/toolstrip/form/DropDownButton",
    "../mixins/property/IconOverrideMixin",
    "../mixins/property/OrientationMixin",
    "../mixins/property/TextOverrideMixin",
    "../mixins/property/TypeMixin",
    "mw-form/mixins/property/ShortcutMixin",
    "../mixins/property/MenuIdMixin",
    "mw-form/mixins/mixinDependencyValidator"
], function (declare, DropDownButton, IconOverrideMixin, OrientationMixin, TextOverrideMixin, 
             TypeMixin, ShortcutMixin, MenuIdMixin, mixinDependencyValidator) {

    return declare(mixinDependencyValidator.validate([DropDownButton, IconOverrideMixin, OrientationMixin,
        TextOverrideMixin, TypeMixin, ShortcutMixin, MenuIdMixin]), {
        visualFamily: "default",
        baseClass: "mwWidget mwSectionDropDownButton mwDropDownButton",
        type: "SectionDropDownButton",
        minWidth: 38,
        orientation: "Vertical",
        verticalHeight: 92,
        doNotSize: true,
        preventRestoreFocus: true,

        postCreate: function () {
            this.inherited(arguments);
            this.set("menuOrientation", "below");

            this.own(
                this.on("keydown", function (e) {
                    switch (e.keyCode) {
                        case 37: // [Left Arrow]
                            if (this.isMenuOpen()) {
                                this.closeMenu();
                            }
                            break;
                        case 38: // [Up Arrow]
                            if (this.isMenuOpen()) {
                                this.closeMenu();
                            }
                            break;
                        case 39: // [Right Arrow]
                            if (this.isMenuOpen()) {
                                this.closeMenu();
                            }
                            break;
                        case 40: // [Down Arrow]
                            if (this.isMenuOpen()) {
                                // If the menu is already open, focus the first child of the SectionPopup
                                var menu = this.get("menu");
                                if (menu && menu.focus) {
                                    menu.focus();
                                }
                            } else {
                                this.openMenu();
                            }
                            break;
                        case 9: // [Tab]
                            if (this.isMenuOpen()) {
                                this.closeMenu();
                            }
                            break;
                        default:
                    }
                }.bind(this))
            );
        },

        _setLabelAttr: function (value) {
            if (typeof value !== "string") {
                throw new Error("'label' property must be of type string.");
            }

            this.set("text", value);

            this.focusNode.setAttribute("title", value);
        },

        _setDescriptionAttr: function () {
            // Sections do not have descriptions
        },

        _setShortcutAttr: function () {
            // Sections do not have shortcuts
        },

        _setPlatformizeShortcutAttr: function () {
            // Sections do not have shortcuts
        },

        _getLabelAttr: function () {
            return this.get("text");
        }
    });

});
